/**
 * This specifies the time for Browser Storage
 * in milliseconds.
 */
export enum BrowserStorageTimeEnum {
  eight_hours = 28800000,
  four_hours = 14400000,
  two_hours = 7200000,
  one_hour = 3600000,
  thirty_minutes = 1800000,
  fifteen_minutes = 900000,
  one_day = 86400000,
}
